/** India pincode lookup via backend proxy (avoids browser CORS on api.postalpincode.in). */
export interface PincodeLookupResult {
  city: string;
  state: string;
  country: string;
}

export async function lookupIndiaPincode(pincode: string): Promise<PincodeLookupResult | null> {
  const cleaned = pincode.replace(/\D/g, '');
  if (cleaned.length !== 6) return null;

  try {
    const response = await fetch(`/api/pincode/${cleaned}`);
    const json = await response.json();
    if (!response.ok || !json.success || !json.data) return null;
    return json.data as PincodeLookupResult;
  } catch {
    return null;
  }
}
